<template>
  <div>
    <!--Loading-->
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    <PageTitle title="Grade-Subject Detail" />

    <div class="columns">
      <div class="column is-4">
        <div v-if="fetchCurrentGradeSubject" class="card mb-2">
          <div style="height: 650px;" class="py-2 card-content">
            <div class="columns">
              <div class="column">
                <p class="subtitle is-6"><b>Grade: </b>{{fetchCurrentGradeSubject.grade.name}}</p>
              </div>
              <div class="column">
                <p class="subtitle is-6"><b>Subject: </b>{{fetchCurrentGradeSubject.subject.name}}</p>
              </div>
            </div>
            
            <b-button size="is-small" type="is-success" @click="addNewCategory()" >New</b-button>
            <treeselect
              ref="treeselect"
              :multiple="false"
              :options="fetchCategories"
              :normalizer="$common.normalizer"
              :defaultExpandLevel="0"
              value-consists-of="ALL"
              placeholder="Select Category/Subcategory *"
              :always-open="true"
              :append-to-body="false"
              search-nested
              :z-index="1"
              :max-height="500"
              @input="showCategoryDetail"
            >
            </treeselect>
          </div>
        </div>
      </div>
      <div class="column is-8">
        <div v-if="fetchCurrentCategory" class="card mb-2">
          <div class="card-content">
            <div class="columns" >
              <div class="column is-12">
                <div class="buttons">
                  <b-button size="is-small" type="is-warning" @click="editCategory(fetchCurrentCategory._id)">Edit</b-button>
                  <b-button size="is-small" type="is-danger" @click="deleteThisCategory(fetchCurrentCategory._id)">Delete</b-button>
                  <b-tag v-if="fetchCurrentCategory.is_not_allowed" type="is-danger">Not Allowed Attempt</b-tag>
                </div>
                <p class="subtitle is-6"><b>Category Name: </b>{{fetchCurrentCategory.name}}</p>
                <p class="subtitle is-6"><b>Category Order: </b>{{fetchCurrentCategory.order}}</p>
                <p class="subtitle is-6"><b>Category Remarks: </b>{{fetchCurrentCategory.remarks}}</p>

              </div>
            </div>
            
            <b-field>
              <div class="buttons">
                <b-button @click="addNewSkill()" type="is-info" size="is-small">New Skill</b-button>
                <b-button :disabled="!checkedSkills.length" @click="showSkillCopy()" type="is-dark" size="is-small" icon-left="content-copy">Copy Skills</b-button>
              </div>
            </b-field>

            <UpTable checkable :checked-rows.sync="checkedSkills" :paginated="false" :data="fetchSkills">
              <UpTableColumn v-slot="props" label="Name">
                <b-tag v-if="props.row.is_not_allowed" type="is-danger">Attempt Not Allowed</b-tag> {{props.row.name}}
              </UpTableColumn>
              <UpTableColumn v-slot="props" field="remarks" label="Remarks">{{props.row.remarks}}</UpTableColumn>
              <UpTableColumn v-slot="props" label="Action">
                <div class="buttons">
                  <b-button @click="showSkillDetail(props.row._id)" type="is-dark" size="is-small" icon-left="eye"></b-button>
                  <b-button @click="editSkill(props.row._id)" type="is-primary" size="is-small" icon-left="pencil"></b-button>
                  <b-button @click="deleteThisSkill(props.row._id)" type="is-danger" size="is-small" icon-left="delete"></b-button>
                </div>
              </UpTableColumn>
              <template #empty>
                <empty-table message="No skills created."></empty-table>
              </template>
            </UpTable>
          </div>
        </div>
      </div>
    </div>


    <!--Set Category-->
    <b-modal :active.sync="modalCategoryActive"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    aria-modal>
      <set-category :category_id="edit_category_id" :grade_subject_id="id" @over="modalCategoryActive = false"></set-category>
    </b-modal>

    <!--Copy Skill-->
    <b-modal :active.sync="modalCopySkillActive"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    aria-modal>
      <form enctype="multipart/form-data">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Copy Skill</p>
          </header>
          <div style="height:400px;" class="modal-card-body">
            <div class="columns is-multiline">
              <div class="column is-12">
                <b-field label="Select Grade Subjects" expanded>
                    <b-select expanded v-model="skill_copy.grade_subject" @input="loadCategoriesOfGradeSubject()">
                      <option v-for="grade_subject in fetchGradeSubjects" :key="grade_subject._id" :value="grade_subject._id">
                        {{grade_subject.subject.name}} - {{grade_subject.grade.name}}
                      </option>
                    </b-select>
                </b-field>
                
                <treeselect
                  ref="treeselect_copy"
                  :multiple="false"
                  :options="categories"
                  :normalizer="$common.normalizer"
                  :defaultExpandLevel="0"
                  value-consists-of="ALL"
                  placeholder="Copy skill to"
                  v-model="skill_copy.to_category"
                  :append-to-body="false"
                  search-nested
                  :z-index="1"
                />
              </div>
              <div class="column is-12">
                <b-button @click="copyThisSkill()" type="is-primary">Copy</b-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <!--Set Skill-->
    <b-modal :active.sync="modalSkillActive"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    aria-modal>
      <set-skill :skill_id="edit_skill_id" :category_id="current_category_id" @over="modalSkillActive = false"></set-skill>
    </b-modal>

    <div v-if="current_skill_id" class="card">
      <div class="card-content">
        <question-table :skill_id="current_skill_id" :category_id="current_category_id"></question-table>
      </div>
    </div>
  </div>
</template>
<script>
//Vuex
import {mapGetters, mapActions} from 'vuex'
import PageTitle from '@/components/PageTitle'
import EmptyTable from '@/components/EmptyTable'
import SetCategory from '@/components/Category/SetCategory'
import SetSkill from '@/components/Skill/SetSkill'
import QuestionTable from '@/components/Question/QuestionTable'

export default {
  name : 'GradeSubjectDetail',
  components : {
    PageTitle, SetCategory, SetSkill, EmptyTable, QuestionTable
  },
  props : {
    id : {
      type : String,
      required : true
    }
  },
  data(){
    return {
      isLoading : false,
      modalCategoryActive : false,
      modalSkillActive : false,
      modalCopySkillActive : false,
      edit_category_id : null,
      edit_skill_id : null,
      current_category_id : null,
      current_skill_id : null,
      current_skill_name : '',
      categories : [],
      filter : {
        subject : null,
        grade : null
      },
      skill_copy : {
        grade_subject : null,
        from_skill : [],
        to_category : null
      },
      checkedSkills : [],
    }
  },
  computed : {
    ...mapGetters(['fetchCurrentGradeSubject', 'fetchGradeSubjects', 'getTeacherToken', 'fetchGrades', 'fetchSubjects', 'fetchCategories', 'fetchCurrentCategory', 'fetchSkills'])
  },
  methods : {
    ...mapActions(['loadGradeSubjectDetails', 'loadGradeSubjects', 'deleteCategory', 'deleteSkill', 'loadSubjects', 'loadGrades', 'loadCategories', 'loadCategoryDetails', 'loadSkills', 'copySkill', 'emptyCurrentCategory']),
    addNewCategory(){
      this.edit_category_id = null
      this.modalCategoryActive = true
    },
    
    editCategory(id){
      this.edit_category_id = id
      this.modalCategoryActive = true
    },
    addNewSkill(){
      this.modalSkillActive = true
    },
    editSkill(id){
      this.modalSkillActive = true
      this.edit_skill_id = id
    },
    showSkillCopy(){
      this.modalCopySkillActive = true
      this.skill_copy.from_skill = this.checkedSkills.map(skill => skill._id)
    },
    loadCategoriesOfGradeSubject(){
      this.isLoading = true
      this.loadCategories({
        token : this.getTeacherToken,
        filter : {
          grade_subject : this.skill_copy.grade_subject,
          tree : true
        },
        do_commit : false
      }).then(res => {
        this.isLoading = false
        this.categories = res.data
      })
    },
    copyThisSkill(){
      this.isLoading = true
      let copy = Object.assign({}, this.skill_copy)
      delete copy.grade_subject
      this.copySkill({
        copy,
        token : this.getTeacherToken
      }).then(() => {
        this.isLoading = false
        this.modalCopySkillActive = false
        this.skill_copy = {
          grade_subject : null,
          from_skill : [],
          to_category : null
        }
        this.$buefy.toast.open({
          message: 'Skill successfully copied. Refresh the page if unable to see',
          type: 'is-success'
        })
      }).catch(err => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: err.response.data,
          type: 'is-danger'
        })
      })
    },
    async showCategoryDetail(id){
      this.isLoading = true
      this.current_category_id = id
      this.checkedSkills = []
      try{
        await Promise.all([
          this.loadCategoryDetails({
            id,
            token : this.getTeacherToken
          }),

          this.loadSkills({
            token : this.getTeacherToken,
            filter : {
              category : id
            }
          })

        ])
      }catch(err){
        this.$buefy.toast.open({
          message: err.response.data,
          type: 'is-danger'
        })
      }

      // Removing previous selected skill
      this.current_skill_id = null
      this.isLoading = false

    },
    showSkillDetail(id){
      //Destroying the earlier component by setting it to null
      this.current_skill_id = null
      //Again creating the component
      this.current_skill_id = id
    },
    deleteThisCategory(id){
      this.$buefy.dialog.confirm({
        title: 'Warning',
        message : 'Are you sure want to delete this category permanently?',
        type : 'is-danger',
        onConfirm: () => {
          this.deleteCategory({
            token : this.getTeacherToken,
            id
          }).then(() => {
            this.$buefy.toast.open({
              message: 'Category deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    },
    deleteThisSkill(id){
      this.$buefy.dialog.confirm({
        title: 'Warning',
        message : 'Are you sure want to delete this skill permanently? This will remove all the questions in the skill',
        type : 'is-danger',
        onConfirm: () => {
          this.deleteSkill({
            token : this.getTeacherToken,
            id
          }).then(() => {
            // Reset current_skill_id if the deleted skill was being viewed
            if (this.current_skill_id === id) {
              this.current_skill_id = null
            }
            this.$buefy.toast.open({
              message: 'Skill deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    }
  },
  watch : {
    fetchCategories : function(new_val){
      if(this.$refs.treeselect){
        this.$refs.treeselect.initialize(new_val)
      }
    },
    categories : function(new_val){
      if(this.$refs.treeselect_copy){
        this.$refs.treeselect_copy.initialize(new_val)
      }
    }
  },
  async created(){
    this.isLoading = true
    // Setting the current category to null
    this.emptyCurrentCategory()
    this.loadGrades({
      token : this.getTeacherToken
    })
    this.loadSubjects({
      token : this.getTeacherToken
    })
    this.loadCategories({
      token : this.getTeacherToken,
      filter : {
        grade_subject : this.id,
        tree : true
      }
    })

    this.loadGradeSubjects({ 
      token : this.getTeacherToken, 
    })

    try{
      await this.loadGradeSubjectDetails({ token : this.getTeacherToken, id : this.id })
    }catch(err){
      this.$buefy.toast.open({
        message: err.response.data,
        type: 'is-danger'
      })
    }
    this.isLoading = false
  }
  
}
</script>